import areIntlLocalesSupported from 'intl-locales-supported';

const supportedLocales = [
  'en',
];

/* eslint-disable global-require */
if (global.Intl) {
  if (!areIntlLocalesSupported(supportedLocales)) {
    const IntlPolyfill = require('intl');
    require('intl/locale-data/jsonp/en');
    Intl.NumberFormat = IntlPolyfill.NumberFormat;
    Intl.DateTimeFormat = IntlPolyfill.DateTimeFormat;
  }
} else {
  global.Intl = require('intl');
  require('intl/locale-data/jsonp/en');
}
/* eslint-enable global-require */

const currencyFormatter = new Intl.NumberFormat(undefined, { style: 'currency', currency: 'USD' });

export const priceFormatter = (price) => currencyFormatter.format(price);

export default {
  priceFormatter,
};
